import faker from 'faker';

export default Array(10)
  .fill(0)
  .map((_, index) => ({
    id: index,
    tipo: faker.lorem.words(1),
    codigo: faker.random.number({ min: 100, max: 500 }).toString(),
    emitente: faker.name.firstName(1),
    destinatario: faker.name.firstName(0),
    dataEntrada: faker.date.past(10).toLocaleString(),
    dataLimiteResposta: faker.date.future(10).toLocaleString(),
    assunto: faker.lorem.words(3),
    areas: [faker.lorem.word(), faker.lorem.word(), faker.lorem.word()],
  }));
